export default __webpack_public_path__ + "images/72b5bec3f06b2021341989508f4e259e-sweidan.png";